<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <CButton color="success" @click="createProduct()" class="mb-4"><CIcon name="cil-plus" height="48"/>{{ $t("Products.AddProduct") }}</CButton>
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
            <CDataTable
              hover
              :items="items"
              :fields="fields"
              :items-per-page="10"
              pagination
              columnFilter
              tableFilter
              sorter
            >
              <template #photo="{item}">
                <td>
                  <img :src="item.photo" style="width: 75px;" alt="">
                </td>
              </template>
              <template #author="{item}">
                <td>
                  <strong>{{item.title}}</strong>
                </td>
              </template>
              <template #reference="{item}">
                <td>
                  <strong>{{item.reference}}</strong>
                </td>
              </template>
              <template #type="{item}">
                <td>
                  <strong>{{item.type}}</strong>
                </td>
              </template>
              <template #provider="{item}">
                <td>
                  {{item.provider}}
                </td>  
              </template>
              <template #price="{item}">
                <td>
                  <strong v-if="item.promo_price>0"><small><del>{{item.price}} DT</del></small> {{item.promo_price}} DT</strong>
                  <strong v-else>{{item.price}} DT</strong>
                </td>
              </template>
              <template #Options="{item}">
                <td class="text-right">
                  <!-- <CButton color="primary" @click="showNote( item.id )" class="mr-2"><CIcon name="cil-center-focus" height="48"/> </CButton> -->
                  <CButton color="warning" @click="editNote( item.id )" class="mr-2"><CIcon name="cil-pencil" height="48"/> </CButton>
                  <CButton v-if="you!=item.id" color="danger" @click="deleteToast( item )"><CIcon name="cil-trash" height="48"/> </CButton>
                </td>
              </template>
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
    <vue-confirm-dialog></vue-confirm-dialog>
  </CRow>
</template>

<script>
import axios from 'axios'
import {batchService, productService} from '../../_services';

export default {
  name: 'Notes',
  data: () => {
    return {
      items: [],
      /*
      fields: [
        {key: 'author'},
        {key: 'title'},
        {key: 'content'},
        {key: 'applies_to_date'},
        {key: 'status'},
        {key: 'note_type'},
        {key: 'show'},
        {key: 'edit'},
        {key: 'delete'}
      ],
      */
      fields: [
        {key: 'photo', label: '#', sorter: false, filter: false},
        {key: 'title', label: 'Titre'},
        {key: 'reference', label: 'Référence'},
        {key: 'type', label: 'Type'},
        {key: 'price', label: 'Prix'},
        {key: 'Options', label: 'Options', sorter: false, filter: false}
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  computed: {
  },
  methods: {
    getRowCount (items) {
      return items.length
    },
    noteLink (id) {
      return `notes/${id.toString()}`
    },
    editLink (id) {
      return `products/${id.toString()}/edit`
    },
    showNote ( id ) {
      const noteLink = this.noteLink( id );
      this.$router.push({path: noteLink});
    },
    editNote ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteNote ( id ) {
      let loader = this.$loading.show();
    
      productService.delete(id).then(function(data){
        this.getProducts()
      }.bind(this)).finally(
          function () {
            loader.hide()
          }.bind(this)
      );
    },
    createProduct () {
      this.$router.push({path: 'products/create'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getProducts (){
      let self = this;
      this.loader = this.$loading.show();
      productService.getAll().then(function (response) {
        self.items = response.data.map((obj)=>{
          obj.photo = JSON.parse(obj.photos)[0];
          return obj;
        });
      }).finally(function () {
        this.loader.hide();
      }.bind(this));
    },
    deleteToast(item){
      this.$confirm(
        {
          message: `Confirmation`,
          message: 'êtes-vous sûr de supprimer l\'article \''+item.title+'\'?',
          button: {
            no: 'Annuler',
            yes: 'Supprimer'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm 
          */
          callback: confirm => {
            if (confirm) {
              this.deleteNote(item.id)
            }
          }
        }
      )
    }
  },
  mounted: function(){
    this.getProducts();
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
